import userResources from "api/userResources";
import React, { useEffect, useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { useNavigate } from "react-router-dom";
import Datepicker from "react-tailwindcss-datepicker";
import Select from "react-tailwindcss-select";
import { toast } from "react-toastify";

const flightTypes = [
  { label: "Economy", value: "economy" },
  { label: "Premium Economy", value: "premium_economy" },
  { label: "Business", value: "business" },
];
export default function () {
  const navigate = useNavigate();
  const [airpotsFrom, setAirpotsFrom] = useState(null);
  const [airpotsTo, setAirpotsTo] = useState(null);
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [infants, setInfants] = useState(0);
  const [selectedFlightType, setSelectedFlightType] = useState("economy");
  const [airport, setAirport] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState();
  const [airportSearch, setAirportSearch] = useState();
  const [directFlight, setDirectFlight] = useState(true);
  const [loading, setLoading] = useState(false);

  const [depart, setDepart] = useState({
    startDate: new Date(),
    endDate: new Date().setMonth(11),
  });

  const handleFlightTypeChange = (event) => {
    setSelectedFlightType(event.target.value);
  };
  const handleDirectflight = (event) => {
    setDirectFlight(event.target.checked);
  };
  const From = (value) => {
    setAirpotsFrom(value);
  };

  const To = (value) => {
    setAirpotsTo(value);
  };

  const departFun = (newValue) => {
    setDepart(newValue);
  };

  const getAirport = async (filter) => {
    const params = {
      iata: filter,
    };
    try {
      const res = await userResources.airport(params);
      const data = res.data.data.map((item) => ({
        value: item?.id,
        label: item?.iata + " " + item?.name,
      }));
      setAirport(data);
    } catch (error) {
      console.error("Failed to fetch airport data:", error);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const data = {
      form_world_airport_id: airpotsFrom?.value,
      to_world_airport_id: airpotsTo?.value,
      departure_date: depart?.startDate,
      // return_date omitted for one-way
      adults: parseInt(adults),
      children: parseInt(children),
      infants: parseInt(infants),
      travel_type: selectedFlightType,
      phone: phoneNumber,
      direct_flight: directFlight,
    };

    try {
      await userResources.submitSearchEnquiry(data);
      // navigate to loading screen with form data
      navigate("/loading", {
        state: {
          fromLabel: airpotsFrom?.label,
          toLabel: airpotsTo?.label,
          departure_date: depart?.startDate,
          adults: parseInt(adults),
          children: parseInt(children),
          infants: parseInt(infants),
          travel_type: selectedFlightType,
          phone: phoneNumber,
          direct_flight: directFlight,
        },
      });
    } catch (err) {
      toast.error(
        "❌ Submission failed. Please try again or call us at 905-244-1300."
      );
    }
  };

  useEffect(() => {
    if (airportSearch) {
      getAirport(airportSearch);
    }
  }, [airportSearch]);

  return (
    <section className="text-gray-800">
      <form onSubmit={onSubmit} className="">
        <div className="">
          <div className="rounded-xl bg-gray-100 p-1 px-3">
            <label className="text-md ">FROM</label>
            <Select
              value={airpotsFrom}
              onChange={From}
              options={airport}
              isSearchable={true}
              onSearchInputChange={(e) => {
                setAirportSearch(e.target.value);
              }}
              loading={false}
              classNames={{
                menuButton: ({ isDisabled }) =>
                  `flex  w-full item-center relative -left-3 border-0 text-lg overflow-hidden text-gray-900 transition-all outline-none duration-300 focus:outline-none cursor-pointer  ${
                    isDisabled
                      ? "bg-gray-200 "
                      : "bg-transparent hover:border-gray-400 cursor-pointer"
                  }`,
                menu: "absolute -top-0 z-10 w-full bg-white shadow-lg border rounded py-1 mt-1.5 text-sm text-gray-700",
                listItem: ({ isSelected }) =>
                  `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate rounded ${
                    isSelected
                      ? `text-white bg-blue-500`
                      : `text-gray-500 hover:bg-blue-100 hover:text-blue-500`
                  }`,
              }}
              formatGroupLabel={(data) => (
                <div
                  className={`flex items-center justify-between py-2 text-xs`}
                >
                  <span className="font-bold">{data.label}</span>
                  <span className="flex  h-5 items-center justify-center rounded-full bg-gray-200 p-1.5">
                    {data.options.length}
                    👉 Airpots
                  </span>
                </div>
              )}
              formatOptionLabel={(data) => (
                <li
                  className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                    !data.isSelected
                      ? `bg-gray-200 text-gray-900`
                      : `bg-blue-800 text-gray-200`
                  }`}
                >
                  {data.label}
                </li>
              )}
            />
          </div>
          <div className="my-2 rounded-xl bg-gray-100 p-1 px-3">
            <label className="text-md" htmlFor="to">
              To
            </label>
            <Select
              id="to"
              value={airpotsTo}
              onChange={To}
              options={airport}
              menuIsOpen={false}
              isSearchable={true}
              onSearchInputChange={(e) => {
                setAirportSearch(e.target.value);
              }}
              loading={false}
              classNames={{
                menuButton: ({ isDisabled }) =>
                  `flex  w-full cursor-pointer  relative -left-3 border-0 text-lg overflow-hidden text-gray-900 transition-all outline-none duration-300 focus:outline-none cursor-pointer ${
                    isDisabled
                      ? "bg-gray-200"
                      : "bg-transparent hover:border-gray-400"
                  }`,
                menu: "absolute -top-0 z-10 w-full bg-white shadow-lg border rounded py-1 mt-1.5 text-sm text-gray-700",
                listItem: ({ isSelected }) =>
                  `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate rounded ${
                    isSelected
                      ? `text-white bg-blue-500`
                      : `text-gray-500 hover:bg-blue-100 hover:text-blue-500`
                  }`,
              }}
              formatGroupLabel={(data) => (
                <div
                  className={`flex items-center justify-between py-2 text-xs`}
                >
                  <span className="font-bold">{data.label}</span>
                  <span className="flex  h-5 items-center justify-center rounded-full bg-gray-200 p-1.5">
                    {data.options.length}
                    👉 Airpots
                  </span>
                </div>
              )}
              formatOptionLabel={(data) => (
                <li
                  className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                    !data.isSelected
                      ? `bg-gray-200 text-gray-900`
                      : `bg-blue-800 text-gray-200`
                  }`}
                >
                  {/* // data represents each option in the list */}
                  {data.label}
                </li>
              )}
            />
          </div>

          <div className="my-2 rounded-xl bg-gray-100 p-1 px-3">
            <div className="flex items-center gap-2">
              <FaCalendarAlt />
              <label className="text-md">DEPART</label>
            </div>
            <Datepicker
              containerClassName=""
              inputClassName="p-0 pt-2 pb-1 bg-transparent outline-0 text-gray-900 w-72 z-50 cursor-pointer "
              toggleClassName="relative hover:text-red-500 "
              popoverDirection="bottom"
              useRange={false}
              asSingle={true}
              value={depart}
              showShortcuts={false}
              // disabledDates={[
              //   {
              //     startDate: "2024-03-04",
              //     endDate: "2023-02-05",
              //   },
              //   {
              //     startDate: "2024-04-05",
              //     endDate: "2023-02-12",
              //   },
              // ]}
              onChange={departFun}
            />
          </div>
          <div className="my-2 rounded-xl bg-gray-100 p-1 px-3 text-gray-300">
            <div className="flex items-center gap-2">
              <FaCalendarAlt />
              <label className="text-md">RETURN</label>
            </div>
            <Datepicker
              containerClassName=""
              inputClassName="p-0 pt-2 pb-1 bg-transparent outline-0 text-gray-300 w-72 cursor-pointer"
              toggleClassName="text-gray-300 "
              popoverDirection="bottom"
              useRange={false}
              asSingle={true}
              value={false}
              showShortcuts={false}
              showFooter={false}
              disabled={true}
              configs={{
                // shortcuts: {
                //   today: "TText",
                //   yesterday: "YText",
                //   past: (period) => `P-${period} Text`,
                //   currentMonth: "CMText",
                //   pastMonth: "PMText",
                // },
                footer: {
                  cancel: "Cencel",
                  apply: "Apply",
                },
              }}
              // disabledDates={[
              //   {
              //     startDate: "2024-03-04",
              //     endDate: "2023-02-05",
              //   },
              //   {
              //     startDate: "2024-04-05",
              //     endDate: "2023-02-12",
              //   },
              // ]}
            />
          </div>
          <div className="my-2 rounded-xl bg-gray-100 p-1 px-3">
            <div className="flex items-center gap-2">
              <FaCalendarAlt />
              <label className="text-md">TRAVELLERS</label>
            </div>
            <div className=" dropdown w-full ">
              <div tabIndex={0} role="button" className="cursor-pointer">
                <h3 className="text-lg">
                  {adults + children + infants} Travellers
                </h3>
                <p className="text-sm">
                  {selectedFlightType === "economy"
                    ? "Economy"
                    : selectedFlightType === "premium_economy"
                    ? "Premium Economy"
                    : selectedFlightType === "business"
                    ? "Business"
                    : ""}
                </p>
              </div>
              <div
                tabIndex={0}
                className="menu dropdown-content z-[1] w-full rounded-box bg-white p-2 shadow "
              >
                <div className="cursor-pointer rounded-md border-b p-2 hover:bg-gray-100">
                  <div className="flex items-center justify-between">
                    <h4>Adults</h4>
                    <h4>{adults}</h4>
                    <div className="flex items-center rounded-md border">
                      <div
                        className="cursor-pointer border border-r-0 p-1 px-3 hover:bg-red-500 hover:text-white"
                        onClick={() => {
                          if (adults > 1) {
                            setAdults(adults - 1);
                          }
                        }}
                      >
                        -
                      </div>
                      <div
                        className="border-s-0 cursor-pointer border p-1 px-3 hover:bg-red-500 hover:text-white"
                        onClick={() => setAdults(adults + 1)}
                      >
                        +
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cursor-pointer rounded-md border-b p-2 hover:bg-gray-100">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4>Children</h4>
                      <h6 className=" text-gray-400">2-12 Years</h6>
                    </div>
                    <h4>{children}</h4>
                    <div className="flex items-center rounded-md border">
                      <div
                        className="cursor-pointer border border-r-0 p-1 px-3 hover:bg-red-500 hover:text-white"
                        onClick={() => {
                          if (children > 0) {
                            setChildren(children - 1);
                          }
                        }}
                      >
                        -
                      </div>
                      <div
                        className="border-s-0 cursor-pointer border p-1 px-3 hover:bg-red-500 hover:text-white"
                        onClick={() => setChildren(children + 1)}
                      >
                        +
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cursor-pointer rounded-md border-b p-2 hover:bg-gray-100">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4>Infants</h4>
                      <h6 className=" text-gray-400">0-23 Months</h6>
                    </div>
                    <h4>{infants}</h4>
                    <div className="flex items-center rounded-md border">
                      <div
                        className="cursor-pointer border border-r-0 p-1 px-3 hover:bg-red-500 hover:text-white"
                        onClick={() => {
                          if (infants > 0) {
                            setInfants(infants - 1);
                          }
                        }}
                      >
                        -
                      </div>
                      <div
                        className="border-s-0 cursor-pointer border p-1 px-3 hover:bg-red-500 hover:text-white"
                        onClick={() => setInfants(infants + 1)}
                      >
                        +
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-1 px-1">
                  {flightTypes.map((type) => (
                    <label
                      key={type.value}
                      className="flex cursor-pointer items-center gap-2 rounded-md py-1 px-1 hover:bg-gray-100"
                    >
                      <input
                        type="radio"
                        name="flightType"
                        value={type.value}
                        checked={selectedFlightType === type.value}
                        onChange={handleFlightTypeChange}
                      />
                      <span>{type.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative mt-2 flex flex-wrap-reverse items-start gap-4 sm:flex-nowrap">
          {/* Checkbox */}
          <div className="flex w-full items-center sm:w-1/2">
            <input
              className="mr-2 mt-2 cursor-pointer"
              type="checkbox"
              id="directFlight"
              name="directFlight"
              checked={directFlight}
              onChange={handleDirectflight}
            />
            <label
              htmlFor="directFlight"
              className="cursor-pointer text-sm sm:text-base"
            >
              Direct Flight
            </label>
          </div>

          {/* Phone Input */}
          <div className="w-full sm:w-1/2">
            <PhoneInputWithCountrySelect
              defaultCountry="CA"
              value={phoneNumber}
              onChange={(value) => setPhoneNumber(value)}
              placeholder="Enter Phone Number"
              className="w-full"
              inputClassName="h-10 w-full !bg-white !text-black px-2 text-lg focus:outline-none"
            />
          </div>
        </div>

        <div className="flex w-full justify-center">
          <button className="btn-grad w-full" type="submit">
            SUBMIT
          </button>
        </div>
      </form>
    </section>
  );
}
